import { useMutationDeleteOrLeaveSpace } from '@fabric-app/business/spaces/mutations/useMutationDeleteOrLeaveSpace';
import { IconTrash } from '@fabric-app/icons/svg';
import { DropdownMenu } from '@fabric-app/ui/components/DropdownMenu/DropdownMenu';
import { PermissionRole } from '@fabric/woody-client';
import { useRouter } from 'next/router';

export const DropdownItemDeleteLeave: React.FC<{
  currentUserRole: PermissionRole;
  spaceId: string;
}> = ({ currentUserRole, spaceId }) => {
  const router = useRouter();
  /**
   * Leave or delete
   */

  const mutationDeleteOrLeaveSpace = useMutationDeleteOrLeaveSpace();

  const handleLeaveOrDelete = () => {
    mutationDeleteOrLeaveSpace.confirmAndMutate(
      {
        space: {
          id: spaceId,
          isOwner: currentUserRole === PermissionRole.OWNER,
        },
      },
      {
        /**
         * we need to push before executing the delete, because the optimistic delete removes the data from the cachce
         */
        onConfirm: () => {
          return router.push('/spaces');
        },
      },
    );
  };

  return (
    <DropdownMenu.Group>
      <DropdownMenu.Item
        iconElement={<IconTrash />}
        onSelect={handleLeaveOrDelete}
        data-testid="space-open-in-tabs-button"
        variant="danger"
      >
        {currentUserRole === PermissionRole.OWNER ? 'Delete' : 'Leave'}
      </DropdownMenu.Item>
    </DropdownMenu.Group>
  );
};
